export default {"src":"/_next/static/media/playground.befe884b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};